import { render, staticRenderFns } from "./deleteSection.vue?vue&type=template&id=18ac97fb"
import script from "./deleteSection.vue?vue&type=script&lang=js"
export * from "./deleteSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports